import { Dispatch } from '../components/architecture/frontend/index'

import { gql } from '@apollo/client';
import { merge } from 'rxjs'
import { map, filter, tap } from 'rxjs/operators'

import _ from 'lodash'

const fragment = `
  fragment ProcessedImageData on ProcessedImage {
    id
    saved
    poNumber
    lineNumber
    orderNumber
    weight
    ffmNumber
    dateReceived
    createdAt
    updatedAt
    processing
  }
  `

const MUTATE_PROCESS_IMAGE = gql`
  mutation processImage(
      $id: Int
      $file: Upload!
    ){
      processImage(
        id: $id
        file: $file
      ) {
        ...ProcessedImageData
      }
    }
    ${fragment}
`;

// GraphQL queries for processed images (exported for use in components)
const GET_PROCESSED_IMAGES = gql`
  query processedImages {
    processedImages {
      ...ProcessedImageData
    }
  }
  ${fragment}
`;

const MUTATE_SAVE_PROCESSED_IMAGE = gql`
  mutation processImageComplete($id: Int!) {
    processImageComplete(id: $id) {
      id
    }
  }
`;

Dispatch.getAction('processImage.process')
  .subscribe(e => Dispatch.nextAction('Request.processImage.process', { type: 'mutation', query: MUTATE_PROCESS_IMAGE, variables: { id: e.id, file: e.file } }))

Dispatch.getAction('processImage.retrieve')
  .subscribe(e => {
    Dispatch.nextAction('Request.processImage.retrieve', { type: 'query', query: GET_PROCESSED_IMAGES, variables: { }, poll: process.env.REACT_APP_POLL_INTERVAL,  retry: process.env.REACT_APP_RETRY_INTERVAL })
  })

Dispatch.getAction('processImage.save')
  .subscribe(e => Dispatch.nextAction('Request.processImage.save', { type: 'mutation', query: MUTATE_SAVE_PROCESSED_IMAGE, variables: { id: e.id } }))

merge(
  Dispatch.getAction('Response.processImage'), 
  Dispatch.getAction('Response.processImage.retrieve'), 
  Dispatch.getAction('Response.processImage.process')
)
  .pipe(
    filter(e => _.isNil(e.errors)),
    map(e => e.data.processedImages ?? e.data.processImage)
  )
  .subscribe(e => Dispatch.nextState('processedImages', e))